exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block);
};
exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block);
};


//////////////////
// WEBPACK FOOTER
// ./~/browserify-aes/modes/ecb.js
// module id = 217
// module chunks = 1